<template>
  <div style="text-align: left; width: 100%;">
    <div
      class="button"
      style="height: auto;"
      @click="showPicker">

      <span style="float: left; text-align: left;">
        <div style="font-size: 16px; min-width: 60px;">
          {{ question.title }}
        </div>
      </span>
      <span style="float: right;">
        <font-awesome-icon icon="edit" style="margin: 0px 10px;" />
      </span>
    </div>
    <!--
      這邊用 v-show 把所有的東西都畫出來是因為 framework7 的 library 有問題，
      如果 array 長度變成 0，再把東西加進去，畫面不會重畫，而且 input 的底線會不見，
      所以決定先畫好，再用 v-show 顯示
    -->
    <div
      v-for="(option, index) in question.options"
      :key="`checkbox-with-number-options-${index}`"
      v-show="question.selectedOptionIds.some(oid => oid === option.id)"
      style="color: gray; margin-left: 20px; font-size: 14px; line-height: 20px;">
      <div>
        <font-awesome-icon icon="check" />
        <span>{{ option.toString() }}</span>
      </div>
      <div>
        <template
          v-for="(subQuestion, index) in option.questions">
          <question
            :key="`checkbox-subquestions-${index}`"
            :itemObj="itemObj"
            :questionId="subQuestion.id">
          </question>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Question from './Question'

export default {
  name: 'CheckboxQuestion',
  dependencies: ['CartElementBuilder'],
  beforeCreate () {
    // circular reference
    this.$options.components.Question = Question
  },
  mounted () {
    this.$nextTick(() => {
      if (this.focus) {
        this.$f7router.navigate(this.questionUrl)
      }
    })
  },
  computed: {
    ...mapState(['store']),
    ...mapGetters(['currentMenu']),
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionId, this.itemObj, this.currentMenu)
    },
    questionUrl () {
      return `/stores/${this.store.id}/items/${this.itemObj.itemBucket}/${this.itemObj.id}.${this.itemObj.instanceId}/questions/${this.questionId}/checkbox-sheet`
    }
  },
  props: {
    questionId: {},
    itemObj: Object,
    focus: Boolean
  },
  methods: {
    showPicker () {
      this.$f7router.navigate(this.questionUrl)
    }
  }
}
</script>
